import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';
export const Navbar: React.FC = () => {
  return <nav className="sticky top-0 z-50 w-full bg-brand-offwhite/90 backdrop-blur-md border-b border-gray-200" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-40 flex items-center justify-between" data-id="element-84">
        <Link to="/" aria-label="El Código del Bienestar — Inicio" className="flex items-center" data-id="element-85">
          <BrandLogo widthPx={280} data-id="element-86" />
        </Link>
        <a href="#pricing" className="hidden sm:inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-full text-white bg-brand-emerald hover:bg-brand-emeraldHover transition-colors shadow-sm hover:shadow-md" data-id="element-87">
          Quiero mi guía
        </a>
      </div>
    </nav>;
};